function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import Link from 'shared/components/Link';
import Paginator from 'shared/components/Paginator';
import { T } from 'shared/helper/translate';
import { convertFormDataToOrderSearchJson, convertOrderSearchJsonToFormData, parseOrderSearchDate } from 'shared/view/order-conversion-service';
import OrderPanel from './OrderPanel';
import OrderSearchForm from './OrderSearchForm';
var Orders = function Orders(_ref) {
  var addMessage = _ref.addMessage,
    displayInvoices = _ref.displayInvoices,
    fetchOrders = _ref.fetchOrders,
    getDownloadUrl = _ref.getDownloadUrl,
    history = _ref.history,
    pagination = _ref.pagination,
    pathname = _ref.pathname,
    searchParams = _ref.searchParams,
    status = _ref.status,
    orders = _ref.orders,
    updateCertificate = _ref.updateCertificate;
  var formData = convertOrderSearchJsonToFormData(searchParams);
  useEffect(function () {
    fetchOrders(formData);
  }, []);
  var performSearch = function performSearch(searchParams) {
    fetchOrders(_objectSpread(_objectSpread({}, searchParams), {}, {
      page: 1
    }));
    history.push("".concat(paginationUrl(searchParams), "1"));
  };
  var handleOnPageChange = function handleOnPageChange(page) {
    return fetchOrders(_objectSpread(_objectSpread({}, convertFormDataToOrderSearchJson(formData)), {}, {
      page: page
    }));
  };
  var paginationUrl = function paginationUrl() {
    var rawSearchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var _ref2 = rawSearchParams || searchParams,
      xid = _ref2.xid,
      orderTitle = _ref2.orderTitle,
      from = _ref2.from,
      to = _ref2.to;
    return ['/researcher/index/orders', xid || '_', orderTitle || '_', parseOrderSearchDate(from), parseOrderSearchDate(to), ''].join('/');
  };
  if (!status.loaded) {
    return /*#__PURE__*/React.createElement("div", {
      id: "async-dashboard-content"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-center dashboard-notice mt-3"
    }, /*#__PURE__*/React.createElement(T, {
      source: "orders-loading-message"
    }), "\xA0", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-spinner-scale",
      spin: true
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "async-dashboard-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "recent-orders-container"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement(T, {
    source: "My Orders"
  })), /*#__PURE__*/React.createElement(OrderSearchForm, {
    orderCount: orders.length,
    initialValues: searchParams,
    onSubmit: performSearch
  }), /*#__PURE__*/React.createElement("div", {
    className: "orders-wrapper"
  }, status.fetching ? /*#__PURE__*/React.createElement("div", {
    className: "orders-loading"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "orders-loading-message"
  }), "\xA0", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }))) : null, orders.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, orders.map(function (order) {
    return /*#__PURE__*/React.createElement(OrderPanel, {
      addMessage: addMessage,
      displayInvoices: displayInvoices,
      getDownloadUrl: getDownloadUrl,
      key: order.externalId,
      order: order,
      pathname: pathname,
      status: status,
      updateCertificate: updateCertificate
    });
  })) : /*#__PURE__*/React.createElement("p", {
    className: "dashboard-notice text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "You have not submitted any manuscripts"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Link, {
    to: "/researcher/submit/new"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Submit a manuscript"
  }), " ", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-chevron-right"
  })))), /*#__PURE__*/React.createElement(Paginator, {
    pagination: pagination,
    url: "".concat(paginationUrl(), "%(page)s"),
    onPageChange: handleOnPageChange,
    updating: status.fetching
  })));
};
export default Orders;